import { render, staticRenderFns } from "./PopupTourism.vue?vue&type=template&id=0759c03c&scoped=true&"
import script from "./PopupTourism.vue?vue&type=script&lang=js&"
export * from "./PopupTourism.vue?vue&type=script&lang=js&"
import style0 from "./PopupTourism.vue?vue&type=style&index=0&id=0759c03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0759c03c",
  null
  
)

export default component.exports